"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var d3 = require("d3");
var resize_observer_polyfill_1 = require("resize-observer-polyfill");
require("./patient.data.component.scss");
var patient_data_service_1 = require("../../core/patient.data.service");
var data_graph_component_1 = require("../../common/chart/linechart/data.graph.component");
var data_graph_component_2 = require("../../common/chart/barchart/data.graph.component");
var date_range_selector_component_1 = require("../../common/date/date-range-selector.component");
var core_2 = require("@ngx-translate/core");
var graph_util_1 = require("../common/graph-util");
var PatientDataComponent = /** @class */ (function () {
    function PatientDataComponent(patientDataService, translateService) {
        this.patientDataService = patientDataService;
        this.translateService = translateService;
        this.leftAxisUltrafiltration = [{
                attribute: 'filling',
                name: this.translateService.instant('Ultrafiltration (kg)'),
            }];
        //
        //    public leftAxisUltrafiltrationSecondary = [{
        //        attribute: 'glucose',
        //        name: this.translateService.instant('Glucose (%)'),
        //    }];
        //
        this.rightAxisUltrafiltration = [{
                attribute: 'patientWeight',
                name: this.translateService.instant('Weight (kg)'),
            }];
        this.cartridgeGraphPresets = [{
                name: this.translateService.instant('Buffer'),
                attributes: [
                    {
                        attribute: 'lactate',
                        name: this.translateService.instant('Lactate (mmol/L)'),
                    }, {
                        attribute: 'nahco3',
                        name: this.translateService.instant('NaHCO3 (mmol/L)'),
                    }
                ],
                rightAttributes: []
            }, {
                name: this.translateService.instant('Reservoir Volume'),
                attributes: [
                    {
                        attribute: 'reservoirVolumeInMl',
                        name: this.translateService.instant('Reservoir volume (ml)'),
                    }
                ],
                rightAttributes: []
            }, {
                name: this.translateService.instant('Chemical composition'),
                attributes: [
                    {
                        attribute: 'glucose',
                        name: this.translateService.instant('Glucose (%)'),
                    }
                ],
                rightAttributes: []
            }];
        //        {
        //                attribute: 'nacl',
        //                name: this.translateService.instant('NaCl (mmol/L)'),
        //        }]
        //
        this.axisCompositeGraph = this.cartridgeGraphPresets[0];
        this.leftAxisDuration = [{
                attribute: 'durationDay',
                name: this.translateService.instant('Dialysis time day (h)'),
            }, {
                attribute: 'durationNight',
                name: this.translateService.instant('Dialysis time night (h)'),
            }];
    }
    Object.defineProperty(PatientDataComponent.prototype, "dateRange", {
        get: function () {
            return this._dateRange;
        },
        set: function (value) {
            this._dateRange = value;
            var range = date_range_selector_component_1.DateRange.fromRange(this._dateRange);
            this.startDate = range.startDate;
            this.endDate = range.endDate;
            this.updateGraph();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PatientDataComponent.prototype, "startDatePlaceholder", {
        get: function () {
            return this.translateService.instant('Start date');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PatientDataComponent.prototype, "endDatePlaceholder", {
        get: function () {
            return this.translateService.instant('End date');
        },
        enumerable: true,
        configurable: true
    });
    PatientDataComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.dateRange = 'week';
        window.addEventListener('resize', function () { return _this.drawGraph(); });
        this.resizeObserver = new resize_observer_polyfill_1.default(function (entries) {
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var entry = entries_1[_i];
                if (entry.target === _this.graphContainerElement.nativeElement) {
                    _this.updateGraph();
                }
            }
        });
        this.resizeObserver.observe(this.graphContainerElement.nativeElement);
    };
    PatientDataComponent.prototype.ngOnDestroy = function () {
        if (this.resizeObserver) {
            this.resizeObserver.unobserve(this.graphContainerElement.nativeElement);
        }
    };
    PatientDataComponent.prototype.setStartDate = function (date) {
        this._dateRange = null;
        this.startDate = date;
        this.updateGraph();
    };
    PatientDataComponent.prototype.setEndDate = function (date) {
        this._dateRange = null;
        this.endDate = date;
        this.updateGraph();
    };
    PatientDataComponent.prototype.fillScreen = function (graphElement) {
        graph_util_1.fillScreen(this.graphElements.toArray().concat(this.barChartElements.toArray()), graphElement);
    };
    PatientDataComponent.prototype.shrinkGraph = function () {
        graph_util_1.shrinkGraph(this.graphElements.toArray().concat(this.barChartElements.toArray()));
    };
    PatientDataComponent.prototype.updateGraph = function () {
        var _this = this;
        if (this.patientNumber) {
            this.patientDataService.getSessionData(this.patientNumber, this.startDate, this.endDate).subscribe(function (res) {
                // format the data
                res.forEach(function (d) {
                    d.date = d3.isoParse(d.startDate);
                    d.filling = d.drainVolumeStart + d.drainVolumeEnd - d.fillingVolume;
                    d.durationDay = d.cartType === 'day' ? d.dialysisDuration / 60 / 60 : null;
                    d.durationNight = d.cartType === 'night' ? d.dialysisDuration / 60 / 60 : null;
                    d.reservoirVolumeInMl = d.reservoirVolume * 1000 * 1000;
                });
                _this.data = res;
                _this.drawGraph();
            });
        }
    };
    PatientDataComponent.prototype.drawGraph = function () {
        this.graphElements.forEach(function (graph) { return graph.drawGraph(); });
    };
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Number)
    ], PatientDataComponent.prototype, "patientNumber", void 0);
    tslib_1.__decorate([
        core_1.ViewChild('graphContainer'),
        tslib_1.__metadata("design:type", core_1.ElementRef)
    ], PatientDataComponent.prototype, "graphContainerElement", void 0);
    tslib_1.__decorate([
        core_1.ViewChildren(data_graph_component_1.DataGraphComponent),
        tslib_1.__metadata("design:type", core_1.QueryList)
    ], PatientDataComponent.prototype, "graphElements", void 0);
    tslib_1.__decorate([
        core_1.ViewChildren(data_graph_component_2.BarChartComponent),
        tslib_1.__metadata("design:type", core_1.QueryList)
    ], PatientDataComponent.prototype, "barChartElements", void 0);
    PatientDataComponent = tslib_1.__decorate([
        core_1.Component({
            selector: 'nano-patient-data',
            template: require('./patient.data.component.html')
        }),
        tslib_1.__metadata("design:paramtypes", [patient_data_service_1.PatientDataService, core_2.TranslateService])
    ], PatientDataComponent);
    return PatientDataComponent;
}());
exports.PatientDataComponent = PatientDataComponent;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/app/data/patient/patient.data.component.ts
// module id = 274
// module chunks = 0